/* src/app/components/enter-personal-promo-code/enter-personal-promo-code.component.scss */
.wrapper {
  text-align: center;
  padding: 20px;
  align-items: center;
}
.wrapper .go-back {
  text-align: right;
  width: 100%;
}
.wrapper .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.wrapper ion-img {
  width: 180px;
  height: 180px;
}
.wrapper h3 {
  padding: 20px;
  color: var(--ion-color-secondary);
}
.wrapper .input-block {
  width: 100%;
}
.wrapper .input-block ion-input {
  border: 1px solid rgb(216, 216, 216);
  --border: 1px solid rgb(213, 213, 213);
  width: 100%;
  transition: all ease-in-out 1s;
  border-radius: 20px;
  margin-right: 10px;
  padding: 20px;
  --padding-end: 10px;
  --padding-start: 20px;
  --highlight-color-focused: transparent;
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
}
.wrapper .input-block ion-input.error {
  border: 1px solid red;
}
.wrapper ion-button {
  margin-top: 20px;
  width: 100%;
}
.error-message span {
  color: red;
  font-size: 12px;
  padding-left: 5px;
}
/*# sourceMappingURL=enter-personal-promo-code.component.css.map */
